import React from 'react';

import { Helmet } from 'react-helmet-async';
import { styled } from 'styled-components';

import PageTitle from 'components/modules/headers/PageTitle';
import ShinroMainButtonArea from 'components/organisms/shinro/ShinroMainButtonArea';
import ShinroSection from 'components/organisms/shinro/ShinroSection';
import SingleColumnTemplate from 'components/templates/SingleColumnTemplate';
import UiStackTemplate from 'components/templates/UiStackTemplate';
import { pageTitles } from 'constants/pageTitles';

import { articleThemes } from './shinroArticles';
import CSSModule from './ShinroIndexPage.module.scss';
import { ShinroRelease } from './types';

const WrapperStyled = styled.div({
  height: '100%',
  display: 'flex',
  marginBottom: 0,
  flexDirection: 'column',
});

const InnerStyled = styled.div(({ theme }) => ({
  width: '100%',
  maxWidth: 780,
  backgroundColor: 'white',

  [theme.media.pc]: {
    margin: `${theme.spacing.xxxl} auto 0`,
  },
  [theme.media.sp]: {
    margin: `${theme.spacing.l} auto 0`,
  },
}));

const currentRelease = (release: string) => ShinroRelease?.current === release;

const ShinroIndexPage: React.FC = () => (
  <>
    <Helmet>
      <title>{pageTitles.shinroInformations}</title>
    </Helmet>
    <SingleColumnTemplate>
      <WrapperStyled>
        <PageTitle title={pageTitles.shinroInformations} />
        <UiStackTemplate isLoading={false} isError={false}>
          <InnerStyled>
            <ShinroMainButtonArea />
            <hr />
            <div className={CSSModule.ShinroSectionArticleHeader}>
              <h1 className={CSSModule.ShinroSectionArticleHeader__Title}>
                保護者向け 受験・進路コラム
              </h1>
              <p className={CSSModule.ShinroSectionArticleHeader__Description}>
                受験・進路の基本的な理解やお悩みや疑問の解消に役立つコラムを【期間限定】でお届けします
              </p>
            </div>
            {articleThemes.map((theme) => (
              <ShinroSection
                key={theme.title}
                title={theme.title}
                articles={theme.articles}
                currentRelease={currentRelease(theme.release)}
              />
            ))}
          </InnerStyled>
        </UiStackTemplate>
      </WrapperStyled>
    </SingleColumnTemplate>
  </>
);

export default ShinroIndexPage;
